export default __webpack_public_path__ + "static/media/rooster.ffd535ed.png";